// extracted by mini-css-extract-plugin
export var centerText = "_ct-8";
export var container = "_ct-0";
export var doughnutContainer = "_ct-7";
export var legend = "_ct-a";
export var legendItemColorDisplay = "_ct-b";
export var legendItemLabel = "_ct-d";
export var legendItemValue = "_ct-c";
export var lg = "_ct-5";
export var maxWidth = "_ct-9";
export var md = "_ct-4";
export var responsive = "_ct-6";
export var sm = "_ct-3";
export var xs = "_ct-2";
export var xxs = "_ct-1";